module.exports = __webpack_public_path__ + "static/media/brand-logo-thumb.90a75e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand-logo-thumb.png
// module id = 117
// module chunks = 0